module.exports = __webpack_public_path__ + "img/75986.6190dc05.svg";